import cartLineItem from './cart-line-item';
import { lockScroll, unlockScroll } from '../utils/util-functions';
import { fetchProductsFromClerk } from '../utils/clerk-recommendations';

export default (node) => {
  const cartButton = document.querySelector('[data-main-cart-button]');
  const mobileCartButton = document.querySelector('[data-mobile-cart-button]');
  const cartDrawerSell = document.querySelector('[data-cart-drawer-sell]');
  const clerkKey = node.getAttribute('data-clerk-key');
  const clerkUpsellLimit = node.getAttribute('data-clerk-upsell-limit');
  const clerkRecommendationsUrl = node.getAttribute('data-clerk-recommendations-url');
  const cartDrawerOverlay = node.querySelector('[data-cart-drawer-overlay]');
  const closeCartDrawerButtons = node.querySelectorAll('[data-close-cart-drawer-button]');
  const moneyFormat = node
    .getAttribute('data-money-format')
    .replace('amount_with_dot_separator', 'amount');
  const selectSize = node.getAttribute('data-select-size');
  const addToCartText = node.getAttribute('data-add-to-cart-text');
  const loadingText = node.getAttribute('data-loading-text');

  let cartItems = node.querySelectorAll('[data-cart-item]');
  let termsCheckbox = node.querySelector('[data-terms-checkbox]');
  let mtoTermsCheckbox = node.querySelector('[data-mto-terms-checkbox]');

  let firstTimeOpen = false;

  const toggleCartDrawer = () => {
    const isExpanded = node.getAttribute('aria-expanded') === 'true';

    if (isExpanded) {
      closeUpsellDrawer();
    }
    node.setAttribute('aria-expanded', !isExpanded);

    // Is reversed because this is the state before the toggle
    if (isExpanded) {
      unlockScroll();
    } else {
      lockScroll();

      // Only open upsell when opening the cart drawer and cart has items
      if (cartItems.length > 0) {
        if (!firstTimeOpen) {
          fetchProductsFromClerk(node.querySelectorAll('[data-cart-item]'), clerkRecommendationsUrl, clerkKey, clerkUpsellLimit, true, moneyFormat, selectSize, addToCartText, null, '[data-cart-drawer-sell-products]', '[data-cart-drawer-sell-products-mobile-embla]', '["Upsell - Cart drawer"]', loadingText);
          firstTimeOpen = true;
        } else {
          openUpsellDrawer();
        }
      }
    }
  };

  const openUpsellDrawer = () => {
    // check window width
    if (window.innerWidth < 990) {
      return;
    }
    if (cartDrawerSell) {
      cartDrawerSell.classList.add('translate-x-0');
      cartDrawerSell.classList.add('right-[830px]');
    }
  };

  const closeUpsellDrawer = () => {
    if (cartDrawerSell) {
      cartDrawerSell.classList.remove('translate-x-0');
      cartDrawerSell.classList.remove('right-[830px]');
    }
  };

  const updateShippingText = () => {
    // These elements are updated when the cart is updated so we need to
    // re-query them when the cart is updated
    const shippingText = node.querySelector('[data-shipping-text]');
    const showShippingText = shippingText.dataset.showShippingText;
    const freeShippingAmount = shippingText.dataset.freeShippingAmount;

    if (showShippingText === 'true') {
      shippingText.innerHTML = shippingText.innerHTML.replace(
        '{AMOUNT}',
        freeShippingAmount
      );
    }
  };

  const updateCartItems = () => {
    if (cartItems.length > 0) {
      cartItems.forEach((item) => {
        cartLineItem(item);
      });
    } else {
      closeUpsellDrawer();
    }
  };

  const saveConsentStateToSession = (e) => {
    const checkbox = e.target;
    const isTermsCheckbox = checkbox.hasAttribute('data-terms-checkbox');
    const isMtoTermsCheckbox = checkbox.hasAttribute('data-mto-terms-checkbox');

    if (isTermsCheckbox) {
      sessionStorage.setItem('cartTermsAccepted', checkbox.checked);
    }

    if (isMtoTermsCheckbox) {
      sessionStorage.setItem('cartMtoTermsAccepted', checkbox.checked);
    }
  };

  const applyStoredConsentState = () => {
    const storedTermsAccepted = sessionStorage.getItem('cartTermsAccepted');
    const storedMtoTermsAccepted = sessionStorage.getItem('cartMtoTermsAccepted');

    if (storedTermsAccepted === 'true' && termsCheckbox) {
      termsCheckbox.checked = true;
    }

    if (storedMtoTermsAccepted === 'true' && mtoTermsCheckbox) {
      mtoTermsCheckbox.checked = true;
    }
  };

  const attachConsentChangeListeners = () => {
    if (termsCheckbox) {
      termsCheckbox.addEventListener('change', saveConsentStateToSession);
    }

    if (mtoTermsCheckbox) {
      mtoTermsCheckbox.addEventListener('change', saveConsentStateToSession);
    }
  };

  const handleCheckoutNavigation = () => {
    const cartPageButton = node.querySelector('[data-cart-drawer-button]');

    if (cartPageButton?.href?.includes('/checkout')) {
      cartPageButton.addEventListener('click', () => {
        sessionStorage.removeItem('cartTermsAccepted');
        sessionStorage.removeItem('cartMtoTermsAccepted');
      });
    }
  };


  const init = () => {
    if (cartButton) {
      cartButton.addEventListener('click', toggleCartDrawer);
    }

    if (mobileCartButton) {
      mobileCartButton.addEventListener('click', toggleCartDrawer);
    }

    if (cartDrawerOverlay) {
      cartDrawerOverlay.addEventListener('click', toggleCartDrawer);
    }

    if (closeCartDrawerButtons) {
      closeCartDrawerButtons.forEach((button) => {
        button.addEventListener('click', toggleCartDrawer);
      });
    }

    updateShippingText();
    updateCartItems();
    applyStoredConsentState();
    attachConsentChangeListeners();
    handleCheckoutNavigation();

    document.addEventListener('cart:open', () => {
      node.setAttribute('aria-expanded', 'true');
      applyStoredConsentState();
      lockScroll();

      // Only open upsell if cart has items
      const currentCartItems = node.querySelectorAll('[data-cart-item]');
      if (currentCartItems.length > 0) {
        if (!firstTimeOpen) {
          fetchProductsFromClerk(currentCartItems, clerkRecommendationsUrl, clerkKey, clerkUpsellLimit, true, moneyFormat, selectSize, addToCartText, null, '[data-cart-drawer-sell-products]', '[data-cart-drawer-sell-products-mobile-embla]', '["Upsell - Cart drawer"]', loadingText);
          firstTimeOpen = true;
        } else {
          openUpsellDrawer();
        }
      }
    });

    document.addEventListener('cart-drawer:open-upsell-drawer', (element) => {
      const currentCartItems = node.querySelectorAll('[data-cart-item]');
      if (element.detail.open && currentCartItems.length > 0) {
        openUpsellDrawer();
      }
    });

    document.addEventListener('cart:update', () => {
      updateShippingText();
      cartItems = node.querySelectorAll('[data-cart-item]');
      termsCheckbox = node.querySelector('[data-terms-checkbox]');
      mtoTermsCheckbox = node.querySelector('[data-mto-terms-checkbox]');
      updateCartItems();

      const closeCartDrawerButtons = node.querySelectorAll(
        '[data-close-cart-drawer-button]'
      );
      if (closeCartDrawerButtons) {
        closeCartDrawerButtons.forEach((button) => {
          button.addEventListener('click', toggleCartDrawer);
        });
      }

      applyStoredConsentState();
      attachConsentChangeListeners();
      handleCheckoutNavigation();

      if (cartItems.length > 0) {
        fetchProductsFromClerk(cartItems, clerkRecommendationsUrl, clerkKey, clerkUpsellLimit, true, moneyFormat, selectSize, addToCartText, null, '[data-cart-drawer-sell-products]', '[data-cart-drawer-sell-products-mobile-embla]', '["Upsell - Cart drawer"]', loadingText);
        firstTimeOpen = true;
      }
    });
  };

  init();
};
